export default __webpack_public_path__ + "static/media/fullscreen.ed2f73f9.svg";